import React from 'react'
import {NavLink} from 'react-router-dom';

function Sidebar() {
  const activeClassName='nav-link';
  const inactiveClassName='nav-link collapsed';
  return (
    <>
    <aside className="sidebar">
        <ul className="sidebar-nav">
            <li className="nav-item">
                <NavLink to="dashboard" className={({isActive})=>isActive ?activeClassName:inactiveClassName}>
                    <i className="bi bi-grid"></i>
                    <span> Dashboard</span>
                </NavLink>
            </li>

            <li className="nav-item">
                <NavLink to="clinics" className={({isActive})=>isActive ?activeClassName:inactiveClassName}>
                    <i className="bi bi-hospital"></i>
                    <span> Clinics</span>
                </NavLink>
            
            </li>

            <li className="nav-item">
                <NavLink to="articles" className={({isActive})=>isActive ?activeClassName:inactiveClassName}>
                    <i className="bi bi-file-medical"></i>
                    <span> Articles</span>
                </NavLink>
            </li>

            <li className="nav-item">
                <NavLink to="surveys" className={({isActive})=>isActive ?activeClassName:inactiveClassName}>
        
                    <i className="bi bi-clipboard-data"></i>
                    <span> Surveys</span>
                </NavLink>
            </li>
            <li className="nav-item">
                <NavLink to="campaign" className={({isActive})=>isActive ?activeClassName:inactiveClassName}>
        
                    <i className="bi bi-megaphone"></i>
                    <span> Campaigns</span>
                </NavLink>
            </li>
            <li className="nav-item">
                <NavLink to="recalls" className={({isActive})=>isActive ?activeClassName:inactiveClassName}>
        
                    <i className="bi bi-repeat"></i>
                    <span> Recalls</span>
                </NavLink>
            </li>
            <li className="nav-heading">Templates</li>
            <li className="nav-item">
                <NavLink to="email-template" className={({isActive})=>isActive ?activeClassName:inactiveClassName}>
                
                    <i className="bi bi-inbox"></i>
                    <span> Email</span>
                </NavLink>
            </li>

            <li className="nav-item">
                <NavLink to="sms-template" className={({isActive})=>isActive ?activeClassName:inactiveClassName}>
                
                    <i className="bi bi-chat-right"></i>
                    <span> SMS</span>
                </NavLink>
            </li>

            <li className="nav-item">
                <NavLink to="telephone-template" className={({isActive})=>isActive ?activeClassName:inactiveClassName}>
                
                    <i className="bi bi-telephone"></i>
                    <span> Telephone</span>
                </NavLink>
            </li>

          

          

            <li className="nav-heading">Admin</li>
          
            <li className="nav-item">
                <NavLink to="process" className={({isActive})=>isActive ?activeClassName:inactiveClassName}>
                    <i className="bi bi-list-task"></i>
                    <span> Process</span>
                </NavLink>
            </li>
           
        </ul>
    </aside>
</>
  )
}

export default Sidebar